
	import Vue from "vue";

	export default Vue.extend({
		name: "CheckboxGroupField",
		props: {
			disabled: {
				type: Boolean,
				default: false,
			},
			options: {
				type: Array,
				default: () => {
					return [];
				},
			},
      required: {
        type: Boolean,
        default: false,
      },
      extraValidations: {
        type: Boolean,
        default: false,
      },
      validation: {
        type: String,
        default: ""
      },
      score: {
        type: Boolean,
        default: false,
      },
      scores: {
        type: Array,
        default: () => {
          return [];
        },
      },
			value: {
				type: Array,
				default: () => {
					return [];
				},
			},
		},
		data() {
			return {
				selectedOptions: this.value,
			};
		},
		watch: {
      value: function (value) {
        this.selectedOptions = value;
      },
			selectedOptions: function (options) {
				// this.selectedOptions = options;
				this.$emit("input", options);
			},
		},
	});
